import { render, staticRenderFns } from "./SupplierPwbMaintain.vue?vue&type=template&id=38c08079&scoped=true"
import script from "./SupplierPwbMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierPwbMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c08079",
  null
  
)

export default component.exports